var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"appBar",attrs:{"no-gutters":"","role":"banner","aria-label":"Logo przekierowujące do strony głównej Usteckiej Karty Mieszkańca"}},[_c('logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }